import { Loading } from '@arcadiapower/shrike';
import { SelectUtilityDialog } from '~/components/select-utility-dialog';
import { MachineScreenStates, ScreenMap } from '~/machines/utils/types';
import { LDClient, LDFlags } from '~/providers/launch-darkly';
import { Dashboard } from '~/screens/dashboard';
import { Unexpected } from '~/screens/errors';
import { UtilityAccountSelection } from '~/screens/utility-account-selection';
import { UtilityAccountSelectionMachine } from './types';

export type UtilityAccountSelectionScreenMap = {
  selectUtilityAccount: ScreenMap<UtilityAccountSelectionMachine>;
  createUtilityAccount: ScreenMap<UtilityAccountSelectionMachine>;
  dashboard: ScreenMap<UtilityAccountSelectionMachine>;
  funnel: ScreenMap<UtilityAccountSelectionMachine>;
  unexpected: ScreenMap<UtilityAccountSelectionMachine>;
};

export const utilityAccountSelectionScreenMap: Readonly<UtilityAccountSelectionScreenMap> = {
  selectUtilityAccount: ({ funnel: { context, matches, send } }) =>
    matches('selectUtilityAccount.fetching') ? (
      <Loading />
    ) : (
      <UtilityAccountSelection
        context={{ utilityAccounts: context.utilityAccounts }}
        onConnectNewUtility={() => send({ type: 'SELECT_NEW_UTILITY_ACCOUNT' })}
        flags={{
          showNewUtilityButton: LDClient.variation(LDFlags.createNewUtilityAccount),
        }}
        next={data => send({ type: 'SELECT_UTILITY_ACCOUNT', data })}
      />
    ),
  createUtilityAccount: ({ funnel: { context, matches, send } }) => (
    <SelectUtilityDialog
      error={context.error}
      onClose={() => send({ type: 'GO_BACK' })}
      onSubmit={data => send({ type: 'CREATE_UTILITY_ACCOUNT', data })}
      pending={matches('createUtilityAccount.submitting')}
    />
  ),
  dashboard: ({ funnel: { context, send } }) => (
    <Dashboard context={{ userId: context.userId }} onBack={() => send({ type: 'GO_BACK' })} />
  ),
  funnel: () => <Loading />,
  unexpected: () => <Unexpected />,
};

// NB: do not consume - if this errors, a state is missing a corresponding screen in the map
export const _completenessCheck: Record<
  MachineScreenStates<UtilityAccountSelectionMachine>,
  any
> = utilityAccountSelectionScreenMap;
